import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";

function PageLayout({
  children,
  maxWidth = "760px",
  showNavbar = true,
  eyebrow,
  title,
  subtitle,
  showBack = false,
  showBottomNav = true,
  centered = false,
  topPadding,
  pageClassName = ""
}) {
  const navigate = useNavigate();

const dynamicPageStyle = {
  ...pageStyle,
  paddingTop: topPadding || pageStyle.paddingTop,
  paddingBottom: showBottomNav
    ? "calc(170px + env(safe-area-inset-bottom))"
    : "24px"
};

const dynamicContentStyle = {
  ...contentStyle,
  maxWidth,
  margin: "0 auto"
};

  return (
    <>
      {showNavbar && <Navbar />}

      <main className={pageClassName} style={dynamicPageStyle}>
        <div style={dynamicContentStyle}>
          {showBack && (
            <button
              type="button"
              onClick={() => navigate(-1)}
              style={backButtonStyle}
            >
              ← Back
            </button>
          )}

          {(eyebrow || title || subtitle) && (
            <header style={headerStyle}>
              {eyebrow && <p style={eyebrowStyle}>{eyebrow}</p>}
              {title && <h1 style={titleStyle}>{title}</h1>}
              {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
            </header>
          )}

          {children}
        </div>
      </main>
    </>
  );
}

const pageStyle = {
  backgroundColor: "#111",
  color: "white",
  minHeight: "100vh",
  fontFamily: "Arial",
  paddingTop: "calc(96px + env(safe-area-inset-top))",
  paddingLeft: "16px",
  paddingRight: "16px",
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  boxSizing: "border-box"
};

const contentStyle = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  margin: "0 auto",
  boxSizing: "border-box"
};

const backButtonStyle = {
  backgroundColor: "#181818",
  color: "white",
  border: "1px solid #2a2a2a",
  borderRadius: "999px",
  padding: "10px 14px",
  fontWeight: "bold",
  cursor: "pointer",
  marginBottom: "20px"
};

const headerStyle = {
  marginBottom: "32px"
};

const eyebrowStyle = {
  color: "#e10600",
  fontWeight: "bold",
  textTransform: "uppercase",
  letterSpacing: "1px",
  fontSize: "12px",
  margin: "0 0 8px"
};

const titleStyle = {
  margin: 0,
  fontSize: "34px",
  lineHeight: "1.1"
};

const subtitleStyle = {
  marginTop: "14px",
  opacity: 0.75,
  lineHeight: "1.6",
  maxWidth: "560px"
};

export default PageLayout;
